import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class EntityEventQueryCriteriaClass extends BaseCriteriaModel {

  local_created_time_from?: Optional<string> = Optional.empty();
  local_created_time_to?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty();

}

export class EntityEventCriteriaModelQuery {
  query = '';

  constructor(entityEventCriteriaModel: EntityEventQueryCriteriaClass) {

    if (!entityEventCriteriaModel) {
      return;
    }

    this.query += entityEventCriteriaModel.local_created_time_from.filter(x => x !== '').map(x => '&local_created_time_from=' + x).orElse('');
    this.query += entityEventCriteriaModel.local_created_time_to.filter(x => x !== '').map(x => '&local_created_time_to=' + x).orElse('');
    this.query += entityEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += entityEventCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += entityEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + entityEventCriteriaModel.status;
    this.query += '&orderBy=' + entityEventCriteriaModel.orderBy;
    this.query += '&order=' + entityEventCriteriaModel.order;
    this.query += '&offset=' + entityEventCriteriaModel.offset + '&limit=' + entityEventCriteriaModel.limit;
  }
}
